import { PageHeader, useResource } from "@/admin/shared";
import { Button, StatusPill, Select } from "@/admin/ui";
import { api, formatApiError } from "@/admin/api";

export default function Departments() {
    const { data, loading, refresh } = useResource("/departments");

    async function toggle(d) {
        try {
            await api.patch(`/departments/${d.id}`, { active: !d.active });
            await refresh();
        } catch (e) {
            alert(formatApiError(e));
        }
    }
    async function changeAccess(d, v) {
        try {
            await api.patch(`/departments/${d.id}`, { data_access_level: v });
            await refresh();
        } catch (e) {
            alert(formatApiError(e));
        }
    }
    async function toggleForms(d) {
        try {
            await api.patch(`/departments/${d.id}`, { forms_enabled: !d.forms_enabled });
            await refresh();
        } catch (e) {
            alert(formatApiError(e));
        }
    }

    return (
        <div data-testid="admin-departments-page">
            <PageHeader
                title="Departments"
                subtitle="Enable, disable, and configure department workspaces for every company."
            />

            {loading ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="glass rounded-3xl p-6 h-[190px] animate-pulse" />
                    ))}
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {(data || []).map((d) => (
                        <div
                            key={d.id}
                            data-testid={`dept-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                            className="glass rounded-3xl p-6 flex flex-col"
                        >
                            <div className="flex items-center justify-between">
                                <div className="font-display text-xl font-medium text-black">{d.name}</div>
                                <StatusPill status={d.active ? "active" : "inactive"} />
                            </div>
                            <div className="mt-1 text-[13px] text-neutral-500">{d.tag}</div>

                            <div className="mt-5 grid grid-cols-2 gap-2 text-[12px]">
                                <div className="rounded-xl bg-white border border-black/5 px-3 py-2">
                                    <div className="text-[10px] tracking-[0.18em] uppercase text-neutral-500">Users</div>
                                    <div className="text-[15px] font-semibold text-black">{d.assigned_users || 0}</div>
                                </div>
                                <div className="rounded-xl bg-white border border-black/5 px-3 py-2">
                                    <div className="text-[10px] tracking-[0.18em] uppercase text-neutral-500">Forms</div>
                                    <div className={`text-[13px] font-semibold ${d.forms_enabled ? "text-emerald-600" : "text-neutral-400"}`}>
                                        {d.forms_enabled ? "Enabled" : "Disabled"}
                                    </div>
                                </div>
                            </div>

                            <div className="mt-3">
                                <div className="text-[10px] tracking-[0.18em] uppercase text-neutral-500">Data access</div>
                                <Select
                                    value={d.data_access_level || "standard"}
                                    onChange={(e) => changeAccess(d, e.target.value)}
                                    className="mt-1.5"
                                    data-testid={`dept-access-${d.id}`}
                                >
                                    <option value="restricted">Restricted</option>
                                    <option value="standard">Standard</option>
                                    <option value="elevated">Elevated</option>
                                </Select>
                            </div>

                            <div className="mt-5 flex items-center justify-between gap-2">
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => toggleForms(d)}
                                    data-testid={`dept-forms-${d.id}`}
                                >
                                    {d.forms_enabled ? "Disable Forms" : "Enable Forms"}
                                </Button>
                                <Button
                                    variant={d.active ? "danger" : "primary"}
                                    size="sm"
                                    onClick={() => toggle(d)}
                                    data-testid={`dept-toggle-${d.id}`}
                                >
                                    {d.active ? "Disable" : "Enable"}
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
